// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import plusIcon from "@/assets/icons/plus.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PlusIconProps = Omit<IconProps, "name">;

export function PlusIcon(props: PlusIconProps): React.ReactNode {
  return <Icon name={plusIcon} {...props} />;
}
